export default __webpack_public_path__ + "media/src/assets/images/speedometer-19f9fa413e085215c0c4c6ea16ab239a.png";